module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5QuCE"))).then(() => module.bundle.root('d181N'));